export default __webpack_public_path__ + "static/media/Uslovi koriscenja kartice pogodnosti Nas heroj.a690ec41.pdf";